import type { IconProps } from '../types/IconProps.ts';
export const CalendarX: IconProps = {
    name: 'CalendarX',
    children: [
        `<path d="M19 4H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M8 2v4M16 2v4M3 10h18M10 14l4 4M10 18l4-4" />`,
    ]
};